export default function (element, callback, distance = 800) {
    const observer = new IntersectionObserver((entries) => {
            if(entries.length === 0) {
                return;
            }

            const entry = entries[0];
            if (entry.intersectionRatio <= 0) {
                return;
            }

            observer.unobserve(element);

            callback();
        }, {
        rootMargin: `0px 0px ${distance}px 0px`
    });

    observer.observe(element);
    return observer;
}

